import React from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { BarChart3Icon } from 'lucide-react';
import { mockCategoryData, mockDepartmentData, mockTrendData } from '../data/mockData';
export function TrendAnalytics() {
  const sortedCategories = [...mockCategoryData].sort((a, b) => b.count - a.count).slice(0, 5);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6" data-id="element-266" data-mp="1cnd0jkfn9x5q">
      <div className="flex items-center mb-6" data-id="element-267" data-mp="1hlxs6vgtz8ik">
        <BarChart3Icon className="w-5 h-5 text-blue-500 mr-2" data-id="element-268" data-mp="1hkmp6xv7m4si" />
        <h2 className="text-lg font-bold text-gray-900" data-id="element-269" data-mp="1mezc5hvw9y90">
          Trend Analytics & Recurring Issues
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-270" data-mp="1qhdpjmgso5sw">
        {/* Issue Categories */}
        <div className="col-span-1" data-id="element-271" data-mp="1vc9o75gjdrez">
          <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-272" data-mp="20cxj427vyseh">
            Top Issue Categories
          </h3>
          <div className="h-64" data-id="element-273" data-mp="1d5w8dhfjzol2">
            <ResponsiveContainer width="100%" height="100%" data-id="element-274" data-mp="1d2qkg5inusqx">
              <BarChart data={sortedCategories} layout="vertical" margin={{
              top: 0,
              right: 20,
              left: 0,
              bottom: 0
            }} data-id="element-275" data-mp="184p1rlp5cvfz">
                <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#f3f4f6" data-id="element-276" data-mp="1vv2vrhral4d7" />
                <XAxis type="number" hide data-id="element-277" data-mp="1ruixubyw9wq0" />
                <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} width={100} data-id="element-278" data-mp="1n2hfc8b4v9rj" />
                <Tooltip cursor={{
                fill: '#f9fafb'
              }} contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
              }} data-id="element-279" data-mp="2ark4s2c0e6wl" />
                <Bar dataKey="count" fill="#6366f1" radius={[0, 4, 4, 0]} barSize={24} data-id="element-280" data-mp="2kupit1flsqbx">
                  {sortedCategories.map((entry, index) => <Cell key={`cell-${index}`} fill={index === 0 ? '#4f46e5' : '#818cf8'} data-id="element-281" data-mp="2fxpcqqir7nkt" data-mpi={index} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Department Volume */}
        <div className="col-span-1" data-id="element-282" data-mp="7mbwp5pdm1z">
          <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-283" data-mp="46xzpnrmj25">
            Volume by Department
          </h3>
          <div className="h-64" data-id="element-284" data-mp="1opx9w3i7lpb9">
            <ResponsiveContainer width="100%" height="100%" data-id="element-285" data-mp="1oqyvh1wupu78">
              <BarChart data={mockDepartmentData} margin={{
              top: 0,
              right: 0,
              left: -20,
              bottom: 0
            }} data-id="element-286" data-mp="1koc0wt8spv6c">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" data-id="element-287" data-mp="1tnz15bpsguxt" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} angle={-45} textAnchor="end" height={60} data-id="element-288" data-mp="23eto6iauzykb" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} data-id="element-289" data-mp="n13ij743d28k" />
                <Tooltip cursor={{
                fill: '#f9fafb'
              }} contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
              }} data-id="element-290" data-mp="kihxtswcd8ak" />
                <Bar dataKey="tickets" fill="#0ea5e9" radius={[4, 4, 0, 0]} barSize={32} data-id="element-291" data-mp="sxtovr78o8v" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Ticket Trend */}
        <div className="col-span-1" data-id="element-292" data-mp="fhkeve3ica80">
          <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-293" data-mp="finb81jln4vb">
            Ticket Volume (7 Days)
          </h3>
          <div className="h-64" data-id="element-294" data-mp="3e4ygx5lr3f8x">
            <ResponsiveContainer width="100%" height="100%" data-id="element-295" data-mp="3j5m5lkmibjzz">
              <LineChart data={mockTrendData} margin={{
              top: 5,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-296" data-mp="3j42ndohaiyvk">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" data-id="element-297" data-mp="31nxfmiclnufo" />
                <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} data-id="element-298" data-mp="2wrgi4xjig3px" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} data-id="element-299" data-mp="2iz0kyddaizwx" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
              }} data-id="element-300" data-mp="28yzw6bwnjrlc" />
                <Line type="monotone" dataKey="tickets" stroke="#10b981" strokeWidth={3} dot={{
                r: 4,
                fill: '#10b981',
                strokeWidth: 2,
                stroke: '#fff'
              }} activeDot={{
                r: 6
              }} data-id="element-301" data-mp="1zcfjsixtd7e5" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-100 pt-6" data-id="element-302" data-mp="24aqq4jowgzrm">
        <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-303" data-mp="299tltdizptmx">
          Recurring Issues Action Plan
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-304" data-mp="2wywedgf5x6w7">
          <div className="bg-indigo-50 rounded-xl p-4 border border-indigo-100" data-id="element-305" data-mp="31qnxx6zwiccu">
            <div className="flex items-center justify-between mb-2" data-id="element-306" data-mp="31sh4kmaikwku">
              <span className="font-semibold text-indigo-900" data-id="element-307" data-mp="3b3won5ltzdig">
                System Access (Encompass)
              </span>
              <span className="bg-indigo-200 text-indigo-800 text-xs font-bold px-2 py-1 rounded" data-id="element-308" data-mp="3721q28vabe8d">
                52 Tickets
              </span>
            </div>
            <p className="text-sm text-indigo-700 mb-3" data-id="element-309" data-mp="3fxhcw5xmgt4g">
              High volume of password resets and access requests.
            </p>

          </div>
          <div className="bg-orange-50 rounded-xl p-4 border border-orange-100" data-id="element-310" data-mp="2o59xt9xrlos6">
            <div className="flex items-center justify-between mb-2" data-id="element-311" data-mp="2o7czwsc6z8d9">
              <span className="font-semibold text-orange-900" data-id="element-312" data-mp="326cl1q0hx54o">
                Salesforce Dashboard Errors
              </span>
              <span className="bg-orange-200 text-orange-800 text-xs font-bold px-2 py-1 rounded" data-id="element-313" data-mp="2x81blge44wmz">
                48 Tickets
              </span>
            </div>
            <p className="text-sm text-orange-700 mb-3" data-id="element-314" data-mp="ceo74fb358ku">
              Processors reporting timeout errors during peak hours.
            </p>
            <button type="button" className="text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 px-3 py-1.5 rounded transition-colors" data-id="element-315" data-mp="2ax9fl6i8s55l">
              Escalate to Salesforce Vendor
            </button>
          </div>
        </div>
      </div>
    </div>;
}